module.exports = __webpack_public_path__ + "assets/a-7-xinzang.c2021b01.svg";